module.exports = __webpack_public_path__ + "static/media/arrow_down.c0a62ac9.svg";